import React, { useCallback, useEffect, useMemo, useState } from 'react';
import classNames                                           from 'classnames';
import { connect }                                          from 'react-redux';
import DV                                                   from 'ts-data-validator';
import { formValueSelector, reset, SubmissionError }        from 'redux-form';
import { useTranslation }                                   from 'react-i18next';

import CloseIcon         from '../../icons/CloseIcon';
import DealerRequestForm from './DealerRequestForm';
import Preloader         from '../../containers/preloader';
import { useUser }       from '../../../providers/user';

const DealerRequest = (props) => {
  const {
          agreement,
          closeModal,
          dispatch,
          modalRef,
          userName,
          userPhone,
        } = props;

  const { t } = useTranslation();
  const {
          appealTypes,
          appealInitialStateLoaded,
          getToken,
          name: {
                  first_name,
                  last_name,
                  patronymic,
                },
          phone,
          send,
          tokenList,
          userInitialStateLoaded,
        }     = useUser();

  const [error, setError]                 = useState(false);
  const [shouldPreload, setShouldPreload] = useState(false);
  const [success, setSuccess]             = useState(false);

  const submitDealerRequestForm = useCallback((event, handleSubmit, valid) => {
    event.preventDefault();

    if (valid) {
      setShouldPreload(true);
    }

    const _token = tokenList.DEALER_REQUEST || null;

    handleSubmit((values) => {
      const validateValues = {
        ...values,
        _token,
      };

      return send(validateValues)
        .then(() => {
          setSuccess(true);
          setError(false);
          dispatch(reset('DealerRequestForm'));
          setShouldPreload(false);
        })
        .catch((errors) => {
          setSuccess(true);
          setError(true);
          setShouldPreload(false);
          throw new SubmissionError(errors);
        });
    })(event);
  }, [send, dispatch, tokenList, success, error]);

  const DealerRequestFormProps = useMemo(() => {
    let name = userName;

    if (!DV.isString(name)) {
      name = null;

      if (DV.isString(first_name) && DV.isString(last_name)) {
        name = `${last_name} ${first_name}`;

        if (DV.isString(patronymic)) {
          name = `${name} ${patronymic}`;
        }
      }
    }

    let props = { submitForm: submitDealerRequestForm };

    if (userInitialStateLoaded && appealInitialStateLoaded) {
      const appealTypeId = appealTypes.find((item) => item.aliasKey === 'DEALER_REQUEST')?.appealTypeId;
      const _token       = tokenList.DEALER_REQUEST || null;

      props.initialValues = {
        appealTypeId,
        subType:  'dealerForm',
        aliasKey: 'DEALER_REQUEST',
        name,
        phone:    userPhone || phone,
        _token,
      };
    }

    return props;
  }, [
    agreement,
    appealInitialStateLoaded,
    appealTypes,
    first_name,
    last_name,
    patronymic,
    phone,
    submitDealerRequestForm,
    tokenList,
    userInitialStateLoaded,
    userName,
    userPhone,
  ]);

  useEffect(() => {
    if (!tokenList.hasOwnProperty('DEALER_REQUEST')) {
      getToken('DEALER_REQUEST');
    }
  }, [tokenList]);

  useEffect(() => {
    setSuccess(false);
    setError(false);
  }, [closeModal]);

  return (
    <>
      {appealInitialStateLoaded && !shouldPreload ? (
        <div
          className={classNames('modal', 'dealer_request_modal', { 'notification': success || error })}
          ref={modalRef}
        >
          <span className={'close'} onClick={closeModal}>
            <CloseIcon />
          </span>
          <div>
            {!success && !error && (
              <h2>
                {t('dealer.sub_title')}
              </h2>
            )}
            {success && (
              <h2 className={'notification_title'}>
                {error
                  ? t('client_order_something_wrong_without_exclamation_mark')
                  : t('client_application_sent')
                }
              </h2>)}
            {!success && !error && (
              <>
                <DealerRequestForm
                  {...DealerRequestFormProps} closeModal={closeModal}
                />
                <p className={'required_fields'}>{t('client_required_fields')}</p>
              </>
            )}
            {success && (
              <p
                className={'notification_description'}
                dangerouslySetInnerHTML={{
                  __html: t(error
                    ? 'client_application_sent_description_error'
                    : 'client_application_sent_description_success'),
                }}
              />
            )}
          </div>
        </div>) : (
        <Preloader />)}
    </>);
};

function mapStateToProps(state) {
  const form = formValueSelector('DealerRequestForm');

  return {
    agreement: form(state, 'agreement') || null,
    userName:  form(state, 'name') || null,
    userPhone: form(state, 'phone') || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DealerRequest);
